module.exports = __webpack_public_path__ + "media/images/pages/i-belong/faces-6ccc6fbb68cf2dca72b5b6c9ddf2fef9.svg";